import { render, staticRenderFns } from "./articleUpdate.vue?vue&type=template&id=01a5c29d&scoped=true&"
import script from "./articleUpdate.vue?vue&type=script&lang=js&"
export * from "./articleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./articleUpdate.vue?vue&type=style&index=0&id=01a5c29d&prod&lang=scss&scoped=true&"
import style1 from "./articleUpdate.vue?vue&type=style&index=1&id=01a5c29d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5c29d",
  null
  
)

export default component.exports